import moment from "moment-timezone";

const DEFAULT_FORMAT = "MM/DD/YYYY";

export function formatDate(date, format = DEFAULT_FORMAT) {
	if (!date) return null;
	return moment(date).format(format);
}

export function parseDate(value, format = DEFAULT_FORMAT) {
	if (!value) return null;
	const m = moment(value, format, true);
	return m.isValid() ? m.toDate() : null;
}

export function startOfDay(date) {
	if (!date) return null;
	return moment(date).startOf("day").toDate();
}

export function endOfDay(date) {
	if (!date) return null;
	return moment(date).endOf("day").toDate();
}

export function startOfDayIso(date, format = null) {
	if (!date) return null;
	const m = format ? moment(date, format) : moment(date);
	return m.startOf("day").toISOString();
}

export function endOfDayIso(date, format = null) {
	if (!date) return null;
	const m = format ? moment(date, format) : moment(date);
	return m.endOf("day").toISOString();
}

export function utcToLocalFormatted(date, dtFormat = DEFAULT_FORMAT) {
	if (!date) return null;
	return moment.utc(date).local().format(dtFormat);
}

export function utcToLocalDate(date) {
	if (!date) return null;
	return moment.utc(date).toDate();
}

export function utcToLocalDateNextDay(date) {
	if (!date) return null;
	return moment.utc(date).add(1, "day").toDate();
}

export function utcDisplay(date, format = DEFAULT_FORMAT) {
	if (!date) return null;
	return moment.utc(date).format(format);
}

export function localFromDisplay(date, format = DEFAULT_FORMAT) {
	if (!date) return null;
	return moment(utcDisplay(date, format), format).toDate();
}

export function toSaveDateIso(date, format = DEFAULT_FORMAT) {
	if (!date) return null;
	// If date is already an ISO string, parse it without format to avoid misinterpretation
	const parsedDate = (typeof date === 'string' && date.includes('T'))
		? moment(date)
		: moment(date, format);
	const newDate = parsedDate.format("YYYY-MM-DD");
	return moment.utc(newDate).toISOString();
}

export function toSaveEndDateIso(date, format = DEFAULT_FORMAT) {
	if (!date) return null;
	// If date is already an ISO string, parse it without format to avoid misinterpretation
	const parsedDate = (typeof date === 'string' && date.includes('T'))
		? moment(date)
		: moment(date, format);
	const newDate = parsedDate.format("YYYY-MM-DD");
	return moment.utc(newDate).endOf("day").toISOString();
}

export function addDays(date, amount) {
	if (!date || !Number.isFinite(amount)) return date;
	return moment(date).add(amount, "days").toDate();
}

export function subDays(date, amount) {
	if (!date || !Number.isFinite(amount)) return date;
	return moment(date).subtract(amount, "days").toDate();
}

export function diffInDays(endDate, startDate) {
	if (!endDate || !startDate) return 0;
	const a = moment.utc(endDate).startOf("day");
	const b = moment.utc(startDate).startOf("day");
	return a.diff(b, "days");
}

